/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { taxPayment } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';
import { invoiceStatus } from './search';
import DutypaidProofDetail from '../add.vue';
function handleEmpty(r, c, v) {
  return v || '-';
}
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  kfqy: {
    label: '客户企业',
    prop: 'inEnterpriseName'
  },
  gys: {
    label: '供应商',
    formatter: row => {
      const { proofType, csoEnterpriseName, supplierEnterpriseName } = row;
      return ['', supplierEnterpriseName, csoEnterpriseName][proofType] || '-';
    }
  },
  wsqy: {
    label: '完税企业名称',
    prop: 'csoEnterpriseName',
    formatter: handleEmpty
  },
  qyNo: {
    label: '纳税人识别号',
    prop: 'enterpriseIdentifierNo',
    formatter: handleEmpty
  },
  month: {
    label: '所得月份',
    prop: 'proofMonth',
    formatter: handleEmpty
  },
  startDate: {
    label: '税款所属期起',
    prop: 'startDt',
    formatter: handleEmpty
  },
  endDate: {
    label: '税款所属期止',
    prop: 'endDt',
    formatter: handleEmpty
  },
  wsCount: {
    label: '完税人数',
    formatter: row => {
      return row['peopleCount'] || 0;
    }
  },
  uploadDt: {
    label: '上传日期',
    prop: 'createDt',
    formatter(r, c, v) {
      return v ? dateFormat(v) : '-';
    }
  },
  newDt: {
    label: '最新上传日期',
    formatter(r) {
      return dateFormat(r.updateDt || r.createDt);
    }
  },
  uploadUserPhone: {
    label: '上传账号',
    prop: 'uploadUserPhone'
  },
  auditStatus: {
    label: '审批状态',
    prop: 'uploadUserPhone',
    render: function(h, ctx, r) {
      const { auditStatus, auditReason } = r;
      if (auditStatus == 2 && auditReason) {
        return (
          <el-button
            type="text"
            onClick={() => {
              ctx.parent.$alert(auditReason);
            }}
          >
            已驳回
          </el-button>
        );
      }
      return (
        <span>
          {(invoiceStatus.find(i => i.key == auditStatus) || {}).name}
        </span>
      );
    }
  },
  operation: {
    label: '操作',
    width: '120px',
    render: function(h, ctx, r) {
      const vm = ctx.parent;
      return (
        <div>
          <el-button
            type="text"
            onClick={() => {
              vm.$xrkDialog({
                title: '完税证明',
                width: '1000px',
                showCancel: false,
                showConfirm: false,
                $slots: {
                  default: vm.$createElement(DutypaidProofDetail, {
                    props: {
                      type: 1,
                      useSupplierEnterpriseName: 1,
                      id: r.id
                    },
                    on: {
                      confirm: () => {
                        vm.saveSuccess();
                        vm.$xrkDialog.remove();
                      }
                    }
                  })
                }
              });
            }}
          >
            查看
          </el-button>
          <el-button
            type="text"
            onClick={() => {
              taxPayment.downloadAnnexAjax({ id: r.id }).then(res => {
                vm.$message.success('下载成功，前往下载中心查看');
              });
            }}
          >
            下载
          </el-button>
        </div>
      );
    }
  },
  operation1: {
    label: '操作',
    width: '240px',
    render: function(h, ctx, r) {
      const vm = ctx.parent;
      return (
        <div>
          <el-button
            type="text"
            onClick={() => {
              vm.$xrkDialog({
                title: '完税证明',
                width: '1000px',
                showCancel: false,
                showConfirm: false,
                $slots: {
                  default: vm.$createElement(DutypaidProofDetail, {
                    props: {
                      type: 1,
                      id: r.id
                    },
                    on: {
                      confirm: () => {
                        vm.saveSuccess();
                        vm.$xrkDialog.remove();
                      }
                    }
                  })
                }
              });
            }}
          >
            查看
          </el-button>
          <el-button
            type="text"
            disabled={r.auditStatus != 1}
            onClick={() => {
              vm.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                taxPayment
                  .detail({
                    id: r.id,
                    type: 3
                  })
                  .then(() => {
                    vm.saveSuccess();
                    vm.$message.success('删除成功');
                  });
              });
            }}
          >
            删除
          </el-button>
          <el-button
            type="text"
            disabled={r.auditStatus == 3}
            onClick={() => {
              vm.$xrkDialog({
                title: '完税证明',
                width: '1000px',
                showCancel: false,
                showConfirm: false,
                $slots: {
                  default: vm.$createElement(DutypaidProofDetail, {
                    props: {
                      type: 2,
                      id: r.id
                    },
                    on: {
                      confirm: () => {
                        vm.saveSuccess();
                        vm.$xrkDialog.remove();
                      }
                    }
                  })
                }
              });
            }}
          >
            重新上传
          </el-button>
          <el-button
            type="text"
            onClick={() => {
              taxPayment.downloadAnnexAjax({ id: r.id }).then(res => {
                vm.$message.success('下载成功，前往下载中心查看');
              });
            }}
          >
            下载
          </el-button>
        </div>
      );
    }
  }
};
